module.exports = __webpack_public_path__ + "img/blue_economy.6823ce17.svg";